import { ELoanType, setLoanType } from '@/context/borrower';
import { store } from '@/context/store';

export function setInitialLoanType(partnerLoanType: ELoanType): void {
    const currentState = store.getState().borrowerReducer.loan.loanType;
    if (currentState !== partnerLoanType) {
        store.dispatch(setLoanType(partnerLoanType));
    }
}
